import styled from 'styled-components/macro';
import { deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS } from 'utils/styles/fonts';

export const Title = styled.div`
  padding: 10px 34px;
  position: absolute;
  top: 0;
  background: ${COLORS.mainColor};
  border-radius: 25px 0 0 0;

  @media ${deviceMin.mobileS} {
  }

  @media ${deviceMin.tablet} {
    padding: 7px 23px;
  }

  @media ${deviceMin.laptopL} {
    padding: 8px 25px;
  }

  @media ${deviceMin.desktop} {
    padding: 10px 34px;
  }

  p {
    ${FONTS.font16}
    color: ${COLORS.white};

    @media ${deviceMin.tablet} {
      ${FONTS.font12}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font14}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font16}
    }
  }

  span {
    ${FONTS.font20}
    color: ${COLORS.white};

    @media ${deviceMin.tablet} {
      ${FONTS.font14}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font20}
    }
  }
`;

export const LeftSide = styled.div`
  ${FLEX_CONTAINER.FlexColumn}

  p {
    ${FONTS.font24}


    @media ${deviceMin.mobileS} {
      ${FONTS.font16}
    };

    @media ${deviceMin.tablet} {
      ${FONTS.font16}
    };

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    };

    @media ${deviceMin.desktop} {
      ${FONTS.font24}
    };
  }

  img {
    margin-top: 10px;

    @media ${deviceMin.mobileS} {
      width: 70.17px;
      height: 9.76px;
    }

    @media ${deviceMin.tablet} {
      width: 70.17px;
      height: 9.76px;
    }

    @media ${deviceMin.laptopL} {
      width: 115px;
      height: 16px;
    }

    @media ${deviceMin.desktop} {
      width: 159.16px;
      height: 23.49px;
    }
  }
`;
export const RightSide = styled.div`
  p {
    ${FONTS.font36}
    color: ${COLORS.blue};

    @media ${deviceMin.mobileS} {
      ${FONTS.font24}
    }

    @media ${deviceMin.tablet} {
      ${FONTS.font24}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font36}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font36}
    }
  }
`;

export const Container = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  width: 474px;
  height: 586px;
  position: relative;

  @media ${deviceMin.mobileS} {
    width: 260px;
    height: auto;
  }

  @media ${deviceMin.tablet} {
    width: 270px;
    height: 372.9px;
  }

  @media ${deviceMin.laptopL} {
    width: 475px;
    height: 587px;
  }

  @media ${deviceMin.desktop} {
    width: 1005px;
    height: 586px;
    border-radius: 10px;
  }

  .image {
    border-radius: 26px;
    width: 474px;
    height: 586px;
    margin-left: 0;

    @media ${deviceMin.mobileS} {
      width: 260px;
      height: auto;
    }

    @media ${deviceMin.tablet} {
      width: 270px;
      height: 372px;
    }

    @media ${deviceMin.laptopL} {
      width: 473px;
      height: 586px;
    }

    @media ${deviceMin.desktop} {
      width: 474px;
      height: 586px;
      border-radius: 23px;
    }
  }

  .mobile-description {
    @media ${deviceMin.mobileS} {
      display: block;
      margin-top: 12px;
    }

    @media ${deviceMin.tablet} {
      display: none;
      margin-top: 0;
    }
  }
`;

export const Info = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 475px;
  padding: 14px 30px;
  bottom: 0;
  background: ${COLORS.white};
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;

  @media ${deviceMin.mobileS} {
    ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
    position: relative;
    margin-top: -20px;
    padding: 10px 15px;
  }

  @media ${deviceMin.tablet} {
    padding: 10px 15px;
    position: absolute;
    margin-top: 0;
    flex-direction: row;
  }

  @media ${deviceMin.laptopL} {
    position: absolute;
    padding: 12px 18px;
    margin-top: 0;
    margin-bottom: 0;
  }

  @media ${deviceMin.desktop} {
    padding: 14px 30px;
    position: absolute;
    margin-top: 0;
  }

  .Info-wrapper {
    ${FLEX_CONTAINER.FlexSpaceBetweenRow}
    width: 100%;
  }
`;

export const OfferParagraph = styled.div`
  width: 350px;
  margin-top: 126px;
  margin-left: 70px;

  h2 {
    margin-bottom: 30px;
    ${FONTS.font24};
  }

  img {
    margin-bottom: 30px;
  }
`;
